<template>
  <div class="page-wrapper">
    <div class="content container-fluid">
      <!-- Header -->
      <div class="page-header">
        <div class="row align-items-center w-100">
          <div class="col-sm-8">
            <h3 class="page-title mb-1 d-flex align-items-center">
              <i class="fa fa-car mr-2 text-primary"></i>
              Quản trị Phân Công Xe
            </h3>
            <ul class="breadcrumb mb-0 small">
              <li class="breadcrumb-item"><router-link to="/">Dashboard</router-link></li>
              <li class="breadcrumb-item active">Phân công xe</li>
            </ul>
          </div>
          <div class="col-sm-4 text-right">
            <button class="btn btn-outline-secondary btn-sm" @click="fetchActive" :disabled="isLoading">
              <i class="fa fa-sync" :class="{ 'fa-spin': isLoading }"></i> Tải lại
            </button>
          </div>
        </div>
      </div>

      <!-- Tabs -->
      <div class="card card-tabs mb-3">
        <div class="card-header p-0 border-bottom-0">
          <ul class="nav nav-tabs nav-tabs-bottom">
            <li class="nav-item">
              <a href="#" class="nav-link" :class="{ active: tab==='ACTIVE' }" @click.prevent="tab='ACTIVE'">
                Đang hoạt động
              </a>
            </li>
            <li class="nav-item">
              <a href="#" class="nav-link" :class="{ active: tab==='HISTORY_XE' }" @click.prevent="tab='HISTORY_XE'">
                Lịch sử theo XE
              </a>
            </li>
            <li class="nav-item">
              <a href="#" class="nav-link" :class="{ active: tab==='HISTORY_TAIXE' }" @click.prevent="tab='HISTORY_TAIXE'">
                Lịch sử theo TÀI XẾ
              </a>
            </li>
          </ul>
        </div>

        <div class="card-body">
          <!-- ACTIVE -->
          <div v-if="tab==='ACTIVE'">
            <div class="form-row mb-3">
              <div class="col-md-4">
                <input v-model="filters.keyword" type="text" class="form-control" placeholder="Tìm theo biển số / tài xế...">
              </div>
              <div class="col-md-3">
                <select v-model="filters.status" class="form-control">
                  <option value="">-- Trạng thái --</option>
                  <option value="ASSIGNED">ASSIGNED</option>
                  <option value="IN_USE">IN_USE</option>
                  <option value="CLOSED">CLOSED</option>
                </select>
              </div>
              <div class="col-md-2">
                <button class="btn btn-primary btn-block" @click="applyActiveFilter">
                  <i class="fa fa-filter"></i> Lọc
                </button>
              </div>
            </div>

            <div class="table-responsive">
              <table class="table table-hover table-striped">
                <thead class="thead-light">
                  <tr>
                    <th style="width: 120px;">Biển số</th>
                    <th>Tài xế</th>
                    <th style="width: 130px;">Loại</th>
                    <th style="width: 130px;">Trạng thái</th>
                    <th style="width: 170px;">Bắt đầu</th>
                    <th style="width: 170px;">Kết thúc</th>
                    <th style="width: 120px;" class="text-right">Thao tác</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="isLoading">
                    <td colspan="7" class="text-center">
                      <i class="fa fa-spinner fa-spin"></i> Đang tải...
                    </td>
                  </tr>
                  <tr v-else-if="filteredActive.length === 0">
                    <td colspan="7" class="text-center text-muted">Không có phân công phù hợp</td>
                  </tr>
                  <tr v-else v-for="pc in filteredActive" :key="pc.id">
                    <td>
                      <div class="d-flex align-items-center">
                        <img v-if="pc.fileUrl" :src="pc.fileUrl" class="rounded mr-2" style="width:36px;height:24px;object-fit:cover;">
                        <span class="font-weight-bold">{{ pc.bienSo }}</span>
                      </div>
                    </td>
                    <td>
                      <div class="d-flex align-items-center">
                        <i class="fa fa-user-circle mr-2 text-secondary"></i>
                        <span>{{ pc.tenTaiXe }}</span>
                      </div>
                    </td>
                    <td><span class="badge badge-info">{{ pc.loai || '—' }}</span></td>
                    <td>
                      <span :class="badgeClass(pc.trangThai)">{{ pc.trangThai }}</span>
                    </td>
                    <td>{{ fmt(pc.startAt) }}</td>
                    <td>{{ fmt(pc.endAt) }}</td>
                    <td class="text-right">
                      <button class="btn btn-sm btn-outline-primary" @click="openHistory(pc)">
                        <i class="fa fa-history"></i> Lịch sử
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- HISTORY BY XE -->
          <div v-else-if="tab==='HISTORY_XE'">
            <div class="form-row mb-3">
              <div class="col-md-4">
                <input v-model.number="formXeId" type="number" min="1" class="form-control" placeholder="Nhập XE ID">
              </div>
              <div class="col-md-2">
                <button class="btn btn-primary btn-block" @click="loadLichSuXe" :disabled="!formXeId">
                  Tải lịch sử
                </button>
              </div>
            </div>

            <div v-if="lichSuXe.length" class="table-responsive">
              <table class="table table-hover table-striped">
                <thead class="thead-light">
                  <tr>
                    <th>Phân công #</th>
                    <th>Biển số</th>
                    <th>Tài xế</th>
                    <th>Loại</th>
                    <th>Trạng thái</th>
                    <th>Bắt đầu</th>
                    <th>Kết thúc</th>
                    <th class="text-right">Lịch sử nhận/trả</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="pc in lichSuXe" :key="pc.id">
                    <td>#{{ pc.id }}</td>
                    <td>{{ pc.bienSo }}</td>
                    <td>{{ pc.tenTaiXe }}</td>
                    <td>{{ pc.loai }}</td>
                    <td>{{ pc.trangThai }}</td>
                    <td>{{ fmt(pc.startAt) }}</td>
                    <td>{{ fmt(pc.endAt) }}</td>
                    <td class="text-right">
                      <button class="btn btn-sm btn-outline-primary" @click="openHistory(pc)">
                        <i class="fa fa-history"></i> Xem
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <p v-else class="text-muted">Chưa có dữ liệu. Nhập Xe ID và bấm “Tải lịch sử”.</p>
          </div>

          <!-- HISTORY BY TÀI XẾ -->
          <div v-else-if="tab==='HISTORY_TAIXE'">
            <div class="form-row mb-3">
              <div class="col-md-4">
                <input v-model.number="formTaiXeId" type="number" min="1" class="form-control" placeholder="Nhập Tài xế ID">
              </div>
              <div class="col-md-2">
                <button class="btn btn-primary btn-block" @click="loadLichSuTaiXe" :disabled="!formTaiXeId">
                  Tải lịch sử
                </button>
              </div>
            </div>

            <div v-if="lichSuTaiXe.length" class="table-responsive">
              <table class="table table-hover table-striped">
                <thead class="thead-light">
                  <tr>
                    <th>Phân công #</th>
                    <th>Biển số</th>
                    <th>Tài xế</th>
                    <th>Loại</th>
                    <th>Trạng thái</th>
                    <th>Bắt đầu</th>
                    <th>Kết thúc</th>
                    <th class="text-right">Lịch sử nhận/trả</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="pc in lichSuTaiXe" :key="pc.id">
                    <td>#{{ pc.id }}</td>
                    <td>{{ pc.bienSo }}</td>
                    <td>{{ pc.tenTaiXe }}</td>
                    <td>{{ pc.loai }}</td>
                    <td>{{ pc.trangThai }}</td>
                    <td>{{ fmt(pc.startAt) }}</td>
                    <td>{{ fmt(pc.endAt) }}</td>
                    <td class="text-right">
                      <button class="btn btn-sm btn-outline-primary" @click="openHistory(pc)">
                        <i class="fa fa-history"></i> Xem
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <p v-else class="text-muted">Chưa có dữ liệu. Nhập Tài xế ID và bấm “Tải lịch sử”.</p>
          </div>
        </div>
      </div>

      <!-- Modal: Lịch sử nhận/trả -->
      <div class="modal fade" :class="{ show: showHistory }" style="display: block;" v-if="showHistory">
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header bg-light">
              <h5 class="modal-title font-weight-bold">
                <i class="fa fa-history mr-2"></i>
                Lịch sử Nhận/Trả – Phân công #{{ currentPc?.id }} ({{ currentPc?.bienSo || '—' }})
              </h5>
              <button type="button" class="close" @click="closeHistory"><span>&times;</span></button>
            </div>
            <div class="modal-body">
              <div v-if="isHistoryLoading" class="text-center py-5">
                <i class="fa fa-spinner fa-spin"></i> Đang tải lịch sử...
              </div>
              <div v-else>
                <div v-if="history.length" class="table-responsive">
                  <table class="table table-sm table-striped">
                    <thead class="thead-light">
                      <tr>
                        <th>Thời điểm</th>
                        <th>Sự kiện</th>
                        <th class="text-right">ODO</th>
                        <th class="text-right">Nhiên liệu (%)</th>
                        <th>Ghi chú</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="h in history" :key="h.id">
                        <td>{{ fmt(h.eventTime) }}</td>
                        <td>
                          <span :class="h.eventType==='RECEIVE' ? 'badge badge-success' : 'badge badge-secondary'">
                            {{ h.eventType }}
                          </span>
                        </td>
                        <td class="text-right">{{ h.odo ?? '—' }}</td>
                        <td class="text-right">{{ h.mucNhienLieu ?? '—' }}</td>
                        <td>{{ h.ghiChu || '—' }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <p v-else class="text-muted mb-0">Chưa có sự kiện nhận/trả cho phân công này.</p>
              </div>
            </div>
            <div class="modal-footer">
              <button class="btn btn-light" @click="closeHistory">Đóng</button>
            </div>
          </div>
        </div>
      </div>
      <div v-if="showHistory" class="modal-backdrop fade show"></div>
    </div>
  </div>
</template>

<script>
import { XePhanCongApi } from "@/services/xePhanCongService";

export default {
  name: "AdminXePhanCong",
  data() {
    return {
      tab: "ACTIVE",
      isLoading: false,
      listActive: [],
      filteredActive: [],
      filters: { keyword: "", status: "" },

      // History modal
      showHistory: false,
      isHistoryLoading: false,
      currentPc: null,
      history: [],

      // Lịch sử theo XE / TÀI XẾ
      formXeId: null,
      formTaiXeId: null,
      lichSuXe: [],
      lichSuTaiXe: [],
    };
  },
  created() {
    this.fetchActive();
  },
  methods: {
    async fetchActive() {
      this.isLoading = true;
      try {
        const data = await XePhanCongApi.getAssigned();
        // data: XePhanCongDto[] (id, xeId, bienSo, fileUrl, taiXeId, tenTaiXe, trangThai, loai, startAt, endAt)
        this.listActive = Array.isArray(data) ? data : [];
        this.applyActiveFilter();
      } catch (e) {
        console.error("fetchActive error:", e);
        this.listActive = [];
        this.filteredActive = [];
      } finally {
        this.isLoading = false;
      }
    },
    applyActiveFilter() {
      const kw = (this.filters.keyword || "").toLowerCase().trim();
      const st = (this.filters.status || "").trim();
      this.filteredActive = this.listActive.filter((x) => {
        const okKw =
          !kw ||
          (x.bienSo && x.bienSo.toLowerCase().includes(kw)) ||
          (x.tenTaiXe && x.tenTaiXe.toLowerCase().includes(kw));
        const okSt = !st || (x.trangThai === st);
        return okKw && okSt;
      });
    },
    badgeClass(st) {
      if (st === "IN_USE") return "badge badge-success";
      if (st === "ASSIGNED") return "badge badge-warning";
      if (st === "CLOSED") return "badge badge-secondary";
      return "badge badge-light";
      }
    ,
    fmt(dt) {
      if (!dt) return "—";
      try {
        // dt có thể là ISO string
        return new Date(dt).toLocaleString();
      } catch {
        return dt;
      }
    },
    async openHistory(pc) {
      this.currentPc = pc;
      this.showHistory = true;
      this.isHistoryLoading = true;
      this.history = [];
      try {
        this.history = await XePhanCongApi.giaoNhanByPhanCong(pc.id);
      } catch (e) {
        console.error("giaoNhanByPhanCong error:", e);
        this.history = [];
      } finally {
        this.isHistoryLoading = false;
      }
    },
    closeHistory() {
      this.showHistory = false;
      this.currentPc = null;
      this.history = [];
      this.isHistoryLoading = false;
    },

    async loadLichSuXe() {
      this.lichSuXe = [];
      if (!this.formXeId) return;
      try {
        this.lichSuXe = await XePhanCongApi.lichSuByXe(this.formXeId);
      } catch (e) {
        console.error("lichSuByXe error:", e);
        this.lichSuXe = [];
      }
    },
    async loadLichSuTaiXe() {
      this.lichSuTaiXe = [];
      if (!this.formTaiXeId) return;
      try {
        this.lichSuTaiXe = await XePhanCongApi.lichSuByTaiXe(this.formTaiXeId);
      } catch (e) {
        console.error("lichSuByTaiXe error:", e);
        this.lichSuTaiXe = [];
      }
    },
  },
};
</script>

<style scoped>
.nav-tabs-bottom .nav-link {
  border: 0;
  border-bottom: 2px solid transparent;
}
.nav-tabs-bottom .nav-link.active {
  border-bottom-color: #007bff;
  font-weight: 600;
}
.modal-backdrop { z-index: 1040; }
.modal { z-index: 1050; }
</style>
